import { render, staticRenderFns } from "./teamView.vue?vue&type=template&id=a4e784d6"
import script from "./teamView.vue?vue&type=script&lang=js"
export * from "./teamView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports